import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Colors } from "@styles/colors";

export const Loader = (): JSX.Element => {
    return (
        <div className="is-flex is-justify-content-center mt-4">
            <FontAwesomeIcon icon={faSpinner} size="4x" color={Colors.darkBlue} className="fa-spin" />
        </div>
    );
};
